import { useState } from 'react';
import { useUI } from 'hooks/index';
import cn from 'classnames';
import Icon from 'components/shared/icon';
import Drawer from 'components/account/salonAccount/drawer/drawer';
import RichText from '../richtext';
import styles from './table.module.scss';

const Table = ({
  salon,
  table,
  isOverview = false,
  hasActions = false,
  showOrder = false,
  global,
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const { toggleDrawer } = useUI();

  const handleToggleDrawer = row => {
    const order = salon.orders.find(o => o.orderNo === row.orderNo);
    setSelectedOrder({ ...row, ...order, status: order.status });
    toggleDrawer();
  };

  return (
    <div>
      <Drawer order={selectedOrder} global={global} />
      <div className={styles.tableContainer}>
        <div className={styles.tableTitle}>
          <h1>{table.title}</h1>
          <span
            onClick={() => table.action && table.action()}
            onKeyDown={() => table.action && table.action()}
            tabIndex="0"
            role="button"
          >
            {table.linktext && table.linktext}
          </span>
        </div>
        <p className={styles.tableDescription}>
          <RichText text={table.description && table.description} />
        </p>
        {table.rows.length ? (
          <div className={styles.table}>
            <table>
              <thead>
                <tr>
                  {table.columns.map(column => (
                    <th>
                      {column.label}{' '}
                      {column.icon && (
                        <span
                          onMouseEnter={() => setShowInfo(true)}
                          onMouseLeave={() => setShowInfo(false)}
                        >
                          <Icon type={column.icon} className={styles[column.icon]} />
                        </span>
                      )}
                      {column.icon && showInfo && (
                        <>
                          <div className={cn(styles.infobox)}>
                            <div className={styles.triangle} />
                            {table.infotext && table.infotext}
                          </div>
                        </>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isOverview
                  ? table.rows.slice(0, 10).map(row => (
                      <tr key={row.orderNo}>
                        {Object.entries(row).map(([key, value]) =>
                          showOrder ? (
                            <td key={value}>{value}</td>
                          ) : (
                            key !== 'orderNo' && <td key={value}>{value}</td>
                          )
                        )}
                        {hasActions && (
                          <td className={styles.link}>
                            <span
                              onClick={() => handleToggleDrawer(row)}
                              onKeyDown={() => handleToggleDrawer(row)}
                              role="button"
                              tabIndex="0"
                            >
                              {global.tables['tables-View']?.text}
                            </span>
                          </td>
                        )}
                      </tr>
                    ))
                  : table.rows.map(row => (
                      <tr key={row.orderNo}>
                        {Object.entries(row).map(([key, value]) =>
                          showOrder ? (
                            <td key={value}>{value}</td>
                          ) : (
                            key !== 'orderNo' && <td key={value}>{value}</td>
                          )
                        )}
                        {hasActions && (
                          <td className={styles.link}>
                            <span
                              onClick={() => handleToggleDrawer(row)}
                              onKeyDown={() => handleToggleDrawer(row)}
                              role="button"
                              tabIndex="0"
                            >
                              {global.tables['tables-View']?.text}
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.table}>No items found</div>
        )}
      </div>
    </div>
  );
};

export default Table;
